<template>
    <div v-if="chartData.datasets.length > 0">
        <Bar :data="chartData" :options="chartOptions" :style="style" />
    </div>
    <div v-else>
        Carregando dados...
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'
import { Bar } from 'vue-chartjs'
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { defineProps } from 'vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const props = defineProps({
  year: Number
});

const chartData = ref({
    labels: [],
    datasets: []
});

const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false
});

const style = ref({
    height: '300px', // Set your desired height here
    width: '100%',
    position: 'relative',
});



onMounted(async () => {
    try {
        const response = await api.get('/dashboard/historyLeads', {params: {'year': props.year}}).then((response)=>{return response;}).catch((error)=>{handleRequestErrors(error.status)});
       
        const apiData = response.data;
        chartData.value = {
            labels: apiData.labels,
            datasets: [
                {
                    label: 'Pendentes',
                    borderColor: 'rgba(255, 166, 0, 0.8)', // RGBA color with 80% opacity
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(255, 166, 0, 0.3)',
                    data: apiData.values_pending
                },
                {
                    label: 'Ativos',
                    borderColor: 'rgba(1,97,38, 0.8)', // RGBA color with 80% opacity
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(1,97,38, 0.3)',
                    data: apiData.values_active
                },
                {
                    label: 'Desistentes',
                    borderColor: 'rgba(128,3,3, 0.8)', // RGBA color with 80% opacity
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(128,3,3, 0.3)',
                    data: apiData.values_give_up
                }
            ]
        };
    } catch (error) {
        console.error('Error fetching data:', error);
    }
});

</script>